/**
 * @fileoverview added by tsickle
 * Generated from: models/account.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { defineModelProperties, model } from '../util/model';
/** @enum {number} */
var AccountBillingDay = {
    Monday: 0,
    Tuesday: 1,
    Wednesday: 2,
    Thursday: 3,
    Friday: 4,
    Saturday: 5,
    Sunday: 6,
};
AccountBillingDay[AccountBillingDay.Monday] = 'Monday';
AccountBillingDay[AccountBillingDay.Tuesday] = 'Tuesday';
AccountBillingDay[AccountBillingDay.Wednesday] = 'Wednesday';
AccountBillingDay[AccountBillingDay.Thursday] = 'Thursday';
AccountBillingDay[AccountBillingDay.Friday] = 'Friday';
AccountBillingDay[AccountBillingDay.Saturday] = 'Saturday';
AccountBillingDay[AccountBillingDay.Sunday] = 'Sunday';
/** @enum {string} */
var AccountBillingFrequency = {
    Daily: "daily",
    Weekly: "weekly",
    Monthly: "monthly",
};
/** @enum {string} */
var AccountStatus = {
    /** The account is open (whether or not it has any future jobs booked). */
    Active: "a",
    /** The account has been closed. */
    Closed: "x",
    /** The account owner has exercised their right to be forgotten. */
    Forgotten: "f",
};
export { AccountStatus };
/**
 * Represents permissions on an account.
 * @record
 */
export function AccountPermissions() { }
if (false) {
    /** @type {?} */
    AccountPermissions.prototype.canHaveAccountSpecialInstructions;
    /** @type {?} */
    AccountPermissions.prototype.canSetAccessKeynest;
    /** @type {?} */
    AccountPermissions.prototype.canSetAccessSupervisor;
    /** @type {?} */
    AccountPermissions.prototype.canViewJobsTable;
    /** @type {?} */
    AccountPermissions.prototype.canViewPropertyExternalId;
    /** @type {?} */
    AccountPermissions.prototype.canViewWorkerInfoOnDay;
    /** @type {?} */
    AccountPermissions.prototype.exactStartTimes;
    /** @type {?} */
    AccountPermissions.prototype.manageProperties;
}
/**
 * Base model for an account, containing all relevant fields returned by the API.
 * @record
 */
function BaseAccountModel() { }
if (false) {
    /** @type {?} */
    BaseAccountModel.prototype.avgPropertyCompleteness;
    /** @type {?|undefined} */
    BaseAccountModel.prototype.billedOn;
    /** @type {?} */
    BaseAccountModel.prototype.billingAddress;
    /** @type {?} */
    BaseAccountModel.prototype.billingFrequency;
    /** @type {?} */
    BaseAccountModel.prototype.hasHadVisits;
    /** @type {?} */
    BaseAccountModel.prototype.isHighValue;
    /** @type {?} */
    BaseAccountModel.prototype.name;
    /** @type {?} */
    BaseAccountModel.prototype.permissions;
    /** @type {?} */
    BaseAccountModel.prototype.status;
    /** @type {?} */
    BaseAccountModel.prototype.vatNumber;
}
/**
 * Optional expandable fields that can be requested from the API.
 * @record
 */
export function AccountExpandables() { }
if (false) {
    /** @type {?|undefined} */
    AccountExpandables.prototype.customers;
    /** @type {?|undefined} */
    AccountExpandables.prototype.initialCustomer;
    /** @type {?|undefined} */
    AccountExpandables.prototype.properties;
}
/**
 * Helper properties for the `Account` model.
 * @record
 */
function AccountModelMixin() { }
if (false) {
    /** @type {?} */
    AccountModelMixin.prototype.isActive;
    /** @type {?} */
    AccountModelMixin.prototype.isForgotten;
}
/**
 * Model representing an account.
 * @record
 */
export function Account() { }
/** @type {?} */
export var account = model.extend((/** @type {?} */ ({
    modelName: 'account'
})));
// Implements helper properties declared in `AccountModelMixin`
defineModelProperties(account, {
    isActive: {
        get: /**
         * @return {?}
         */
        function () {
            return this.status === AccountStatus.Active;
        }
    },
    isForgotten: {
        get: /**
         * @return {?}
         */
        function () {
            return this.status === AccountStatus.Forgotten;
        }
    }
});
